// URL de l'API email - fonctionne en local (dev) ET en production
export const API_EMAIL_URL = import.meta.env.DEV 
  ? 'http://localhost/limousine-service3/api/email.php' 
  : '/api/email.php';

